import { Trans, useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { FormHelperText, Link, Stack } from '@mui/material';

import { i18nNS } from '../../../i18n';
import Layout from '../Layout';
import { NextButton, StyledTextField } from './styles';
import useLoginEmailVM, { VALIDATION_TYPES } from './vm';
import Typography from '../../../components/Typography';

const LoginEmail = () => {
  const { t } = useTranslation([i18nNS.AUTH, i18nNS.GLOSSARY, i18nNS.VALIDATION]);

  const { formMethods, onSubmit, handleEmailBlur, acadlyHelpUrl, acadlySignupUrl } = useLoginEmailVM();
  const { handleSubmit, control, formState } = formMethods;
  const { isSubmitting, errors } = formState;

  return (
    <Layout
      title={t('log_in', { ns: i18nNS.AUTH })}
      footer={
        <>
          <Typography variant="textSmMedium" color="common.black">
            {t('don_t_have_an_acadly_account_yet', { ns: i18nNS.AUTH })}
          </Typography>
          <Typography
            variant="textSmBold"
            href={acadlySignupUrl}
            aria-label={t('click_to_create_a_new_account', { ns: i18nNS.AUTH })}
            component={Link}
          >
            {t('sign_up_here', { ns: i18nNS.AUTH })}
          </Typography>
        </>
      }
    >
      <Stack gap={6} component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div>
          <StyledTextField
            control={control}
            name="emailId"
            type="email"
            label={t('registered_email', { ns: i18nNS.AUTH })}
            required
            size="medium"
            placeholder={t('enter_your_email_here', { ns: i18nNS.AUTH })}
            autoComplete="none"
            autoCapitalize="none"
            autoCorrect="off"
            fullWidth
            onBlur={handleEmailBlur}
            autoFocus
          />
          <input hidden type="password" autoComplete="current-password" />
          {errors['emailId']?.type === VALIDATION_TYPES.EMAIL_NOT_FOUND && (
            <FormHelperText error aria-label={t('this_email_id_does_not_exist', { ns: i18nNS.AUTH })}>
              {t('this_email_id_does_not_exist', { ns: i18nNS.AUTH })}
            </FormHelperText>
          )}
        </div>
        <NextButton
          type="submit"
          size="medium"
          isLoading={isSubmitting}
          aria-label={t('click_to_login', { ns: i18nNS.AUTH })}
        >
          {t('next', { ns: i18nNS.GLOSSARY })}
        </NextButton>
      </Stack>
    </Layout>
  );
};

export default LoginEmail;
